import React from "react"
import PropTypes from "prop-types"
import SidebarContent from "./SidebarContent"

const Sidebar = ({ onToggle }) => (
  <div className="vertical-menu">
    <SidebarContent onToggle={onToggle} />
  </div>
)

Sidebar.propTypes = {
  onToggle: PropTypes.func,
}

export default Sidebar
